module.exports = __webpack_public_path__ + "media/images/pages/img_largeStore_01-59c8dc09c09ef18ce85798a92bc058e9.jpg";